import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { SearchResult } from '../../models/search.model';
import { ReportdashboardService } from '../../services/reportdashboard.service';
import { VersionHistoryComponent } from '../version-history/version-history.component';
import { ReportAuditRecord } from '../../models/report.model';
import { environment } from '../../../environments/environment';
import { NotifierService } from 'angular-notifier';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SelectItem, FilterService } from 'primeng/api';
import { Table } from 'primeng/table';
import { stringify } from 'querystring';
declare let gtag: Function;


@Component({
  selector: 'app-searchresults',
  templateUrl: './searchresults.component.html',
  styleUrls: ['./searchresults.component.css']
})
export class SearchresultsComponent implements OnInit {

  filelocationapi: string = environment.apiEndpoint + "/Report/DownloadReportByFileName?fileName=";
  constructor(private router: Router, private reportDashboardService: ReportdashboardService, private notifier: NotifierService,private filterService: FilterService) { }

  @ViewChild('dt') dt: Table;
  @Input()searchResults: SearchResult[];
  reportAuditTrailData:ReportAuditRecord[];
  firstPage: number;
  reportId: number;
  displayHistoryDlg:boolean=false;
  @ViewChild(VersionHistoryComponent) versionHistory: VersionHistoryComponent;
  //totalrecs:number=this.searchResults.length;
  reportCategories: SelectItem[];
  reportYears: SelectItem[];
  countryNames: SelectItem[];
  posts: SelectItem[];
  distributionType: SelectItem[];
  reportTypes: SelectItem[];
  ngOnInit() {

    this.filterService.register('array-some', (value: any, filters) => {
      if (filters === undefined || filters === null || filters.length === 0) {
          return true;
      }

      return filters.some(r=>value.split(';').includes(r))
    });
  }

  ngOnChanges(){
    if(this.searchResults?.length>0){
      this.reportCategories = this.ExpandReportCategories(this.searchResults.map(r => r.reportCategory))
      this.reportCategories = this.GetUniqueValues(this.reportCategories);
      this.reportYears = this.GetUniqueValues(this.searchResults.map(r => new Date(r.reportDate).getFullYear()));
      this.searchResults.forEach(item => {
        item.reportYear = new Date(item.reportDate).getFullYear();
      })
      this.countryNames = this.GetUniqueValues(this.searchResults.map(r => r.countryName));
      this.posts = this.GetUniqueValues(this.searchResults.map(r => r.postName));
      this.distributionType = [{label: 'Internal', value: false},{label: 'Public', value: true}] //isPublic
      this.reportTypes = [{label: 'Required', value: true},{label: 'Voluntary', value: false}] //
    }
  }

  trackDownload(reportName){
    gtag('event', 'report_download', {
      'report_name': reportName
    });
    gtag('event', '\"' + reportName + '\"', {
      'report_name': reportName
    });
  }


  OpenFile(reportName: any) {
    // var windowfeatures = "status=yes";

    window.open(environment.apiEndpoint + "/Report/DownloadReportByFileName?fileName=" + reportName, '_blank');
    //window.open(environment.apiEndpoint+"/Report/DownloadReportByFileName?fileName="+reportName, '_blank',windowfeatures);
    //window.open(environment.apiEndpoint+"/ReportSchedule/DownloadPublishedReportPDF?reportId="+reportId, '_blank');
    //  this.reportDashboardService.downloadPDF$(reportId).subscribe((content:Blob)=>{

    //  // window.open(environment.apiEndpoint+"/Report/DownloadReportByFileName?fileName="+reportName, '_blank');
    //   const fileURL = window.URL.createObjectURL(content);
    //   setTimeout(() => window.open(fileURL, '_blank'), 1000);
    // //   // var a = document.createElement("a");
    // //   // document.body.appendChild(a);
    // //   // //a.style = "display: none";

    // //   //      //var json = JSON.stringify(content);
    // //   //      //blob = new Blob([json], {type: "octet/stream"});
    // //   //      let url = window.URL.createObjectURL(content);
    // //   //     a.href = url;
    // //   //     a.download = reportName+".pdf";
    // //   //     a.target ="_blank";
    // //   //     a.click();
    // //   //     window.URL.revokeObjectURL(url);


    //  },error=>{
    //    this.notifier.notify('error', 'File not found ,please contact administrator');
    //  });
  }
  paginate(event) {
    this.firstPage = event.first;
  }

  resetPageIndex() {
    this.firstPage = 0;
  }
  LaunchReport(Id: any) {
    //console.log(Id);

    this.reportDashboardService.launchReport(Id).subscribe(
      (data) => {


        // console.log(data);
        var accessLink = environment.serverUrl + "/" + data; // "ms-word:ofe|u|"+ environment.serverUrl+"/"+ data;
        const link = document.createElement('a');
        link.href = accessLink;
        link.setAttribute('visibility', 'hidden');
        link.click();
        //TODO: The above code is not working for IE but works for Chorme
        //window.open(this.accessLink);


      }

    );
    //this.voluntaryMetadataForm.disable();
    //console.log(this.accessLink);

  }

  ViewPreviousVersions(id){
    this.versionHistory.ShowReportHistoryDlg(id);
    this.displayHistoryDlg = true;
  }

  ExpandReportCategories(vals: any[]): any[] {
    var returnArry = new Array<any>();
    var seperatedArray: String;
    seperatedArray = vals.join(';');
    returnArry = seperatedArray.split(';');
    return returnArry;
  }

  GetUniqueValues(vals: any[]): SelectItem[] {
    var returnArry = new Array<SelectItem>();
    for (let cnt = 0; cnt < vals.length; cnt++) {
      if (vals)

      if (returnArry.filter(r => r.label == vals[cnt]).length == 0)
        returnArry.push({ label: vals[cnt], value: vals[cnt] });
    }

    returnArry.sort(
      (a, b): number => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      }
    );
    return returnArry;
  }

}
